import { render, staticRenderFns } from "./solutionDetails10.vue?vue&type=template&id=2743b641&scoped=true&"
import script from "./solutionDetails10.vue?vue&type=script&lang=js&"
export * from "./solutionDetails10.vue?vue&type=script&lang=js&"
import style0 from "./solutionDetails10.vue?vue&type=style&index=0&id=2743b641&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2743b641",
  null
  
)

export default component.exports